
define('app/board/models/rosterPositionModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var RosterPositionModel = Backbone.Model.extend({	
		defaults: {
			id: null, //draftPosition:pos:posRank
			pickId: null,
			keeper: false, //
			playerPos: null, //
			byeWeek: null, //
			teamAbbr: null, //
			fName: null, //
			lName: null, //
			auctionValue: null,
			fantasyTeamId : null, //
			draftablePlayerId : null,
			lgPos: null, //
			posRank: null, //
			optional: null,
	    },

	    initialize: function() {
	    	
	    },
	    
	    clearPlayerInfo: function() {
	    	this.set({pickId: null,
	    		keeper: false,
	    		playerPos: null,
	    		byeWeek: null,
	    		teamAbbr: null,
	    		fName: null,
	    		lName: null,
	    		auctionValue: null,
	    		draftablePlayerId : null,
	    	}, {});
	    }
	});
	
	return RosterPositionModel;  
});